<div class="flex flex-col justify-stretch gap-3 px-4">
	<div class="mt-4 flex items-center gap-2">
		<ng-container *ngTemplateOutlet="rangePicker"></ng-container>
		@if (canDrillBack$ | async) {
		<div class="mat-bg-card flex items-center justify-center rounded-full w-[50px] h-[50px]">
			<button
				(click)="drillBack()"
				[matTooltip]="'utils.back' | translate"
				mat-icon-button
			>
				<mat-icon>undo</mat-icon>
			</button>
		</div>
		}
	</div>
	@if(legacyInfoDisplay$.value$ | async; as legacyInfoDisplay) { @if(legacyInfoDisplay !== "none") {
	<div
		class="flex items-start gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-400/40 dark:bg-blue-950/30"
		role="status"
	>
		<div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-500 text-white my-auto">
			<span class="text-sm font-semibold leading-none">i</span>
		</div>
		<div class="flex min-w-0 flex-1 flex-col gap-0.5">
			<span class="font-semibold leading-snug text-blue-700 dark:text-blue-300">
				{{
					( legacyInfoDisplay == "rangeBefore" ? "reports.legacyTimes.title": "reports.legacyTimes.titleDateWithin") | translate
				}}
			</span>
			<span class="text-sm leading-snug text-gray-700 dark:text-blue-100/80 whitespace-pre-line"
				>{{
					(legacyInfoDisplay == "rangeBefore"
						? "reports.legacyTimes.description"
						: "reports.legacyTimes.descriptionDateWithin"
					)
						| translate
							: {
									legacyDate: (legacyDate$.value$ | async) | formatDate,
									beforeLegacyDate: (beforeLegacyDate$.value$ | async) | formatDate,
								}
				}}
			</span>
			@if(legacyInfoDisplay == "rangeWithin") {
			<span class="flex items-center gap-1 text-sm">
				<mat-icon
					class="!text-sm shrink-0"
					inline
					>emoji_objects</mat-icon
				>
				{{ "reports.legacyTimes.tipp" | translate }}
			</span>
			}
		</div>
		<a
			[href]="'reports.legacyTimes.learnMoreUrl' | translate | safeUrl"
			class="ml-auto flex shrink-0 items-center gap-1 self-center whitespace-nowrap text-sm font-semibold text-blue-700 dark:text-blue-300"
			rel="noopener noreferrer"
			target="_blank"
		>
			<span>{{ "reports.legacyTimes.learnMore" | translate }}</span>
			<mat-icon
				class="!text-base"
				inline
				>open_in_new</mat-icon
			>
		</a>
	</div>
	}}
	<div class="timeChart-container">
		<app-loader
			[enableCircle]="true"
			[isActive]="this.timeLoading$ | async"
			[isAfterViewInit]="false"
			class="rounded"
		></app-loader>
		<tg-reports-graph
			[data]="data$graph.value$ | async"
			[drillable]="(graphDrillable$ | async) === true"
			[formatDurationTotals]="false"
		></tg-reports-graph>
	</div>
	<div class="grid grid-cols-1 md:grid-cols-[1fr_240px] items-start justify-start gap-6 pr-4">
		<div class="flex-fill mb-2 flex items-stretch sm:flex-auto">
			<tg-schedules-table [data]="(this.data$table | async)?.[0]"></tg-schedules-table>
		</div>
		<div class="mb-2 flex flex-initial flex-col space-y-3">
			<ng-container *ngTemplateOutlet="(auditRulebreaks.value$ | async) ? statsRulebreaks : stats"></ng-container>
		</div>
	</div>
</div>
<ng-template #rangePicker>
	<app-time-range-picker
		[(range)]="range"
		[allowDynamic]="true"
		[disabled]="timeLoading$ | async"
		#rangePickerComponent
	></app-time-range-picker>
</ng-template>
<ng-template #statsRulebreaks>
	@if (data$statsRulebreaks | async; as tds) {
	<div class="flex flex-col gap-2">
		<div class="flex flex-col gap-2">
			<div class="summed-report-time flex flex-col">
				<span class="summed-report-time-header mat-text-primary">{{
					'supervisor.dashboard_stats.all' | translate
				}}</span>
				<span>{{ tds.errors }}</span>
			</div>
			<div class="summed-report-time flex flex-col">
				<span class="summed-report-time-header mat-text-primary">{{
					'supervisor.dashboard_stats.break' | translate
				}}</span>
				<span>{{ tds.breaks }}</span>
			</div>
			<div class="summed-report-time flex flex-col">
				<span class="summed-report-time-header mat-text-primary">{{
					'supervisor.dashboard_stats.maxHours' | translate
				}}</span>
				<span>{{ tds.dailyMax }}</span>
			</div>
			<div class="summed-report-time flex flex-col">
				<span class="summed-report-time-header mat-text-primary">{{
					'supervisor.dashboard_stats.breakBetweenDays' | translate
				}}</span>
				<span>{{ tds.breakBetweenDays }}</span>
			</div>
		</div>
	</div>
	}
</ng-template>
<ng-template #stats>
	@if ( data$stats | async; as tds ) {
	<div class="flex flex-col gap-2">
		<div class="flex flex-col gap-2">
			@if ((data$Visible | async).filterActive ) {<!-- basic values--> @if(workspaceScheduleEnabled | async ) {
			<div class="summed-report-time flex flex-row justify-between items-center">
				<span class="summed-report-time-header font-bold">{{ 'schedules.dashboard.should' | translate }}</span>
				<span>{{ tds.should | parseMsAsDuration }}</span>
			</div>
			}
			<!-- future time -->
			@if(workspaceScheduleEnabled | async ) {
			<div class="summed-report-time flex flex-row justify-between items-center">
				<div class="flex items-center gap-1">
					<mat-icon [style.color]="'#619CD7'">stop</mat-icon>
					<span class="summed-report-time-header">{{ 'schedules.dashboard.future' | translate }}</span>
				</div>
				<span>{{ tds.future | clamp: 0 | parseMsAsDuration: false : true }}</span>
			</div>
			}
			<div class="summed-report-time flex flex-row justify-between items-center">
				<span class="summed-report-time-header font-bold">{{ 'schedules.dashboard.is' | translate }}</span>
				<span>{{ tds.summed | parseMsAsDuration }}</span>
			</div>
			}
			<div>
				@if ((data$Visible | async).showWork) {
				<div class="summed-report-time flex flex-row justify-between items-center">
					<div class="flex items-center gap-1">
						<mat-icon [style.color]="'#FBBA00'">stop</mat-icon>
						<span class="summed-report-time-header">{{ 'schedules.dashboard.workTime' | translate }}</span>
					</div>
					<span>{{ tds.workTime | parseMsAsDuration }}</span>
				</div>
				} @if ((data$Visible | async).filterActive && (workspaceScheduleEnabled | async )) {<!-- Drop down for
				+/- hours -->
				<div class="summed-report-time flex flex-row justify-between items-center pt-2">
					<span class="summed-report-time-header">{{ 'schedules.dashboard.difference' | translate }}</span>
					<div class="flex items-center gap-1">
						<span>{{ tds.difference | parseMsAsDuration: false : true }}</span>
						<mat-icon (click)="statsDifferenceExpand$.update(!statsDifferenceExpand$.value)">
							{{ statsDifferenceExpand$.value ? 'keyboard_arrow_up' : 'keyboard_arrow_left' }}
						</mat-icon>
					</div>
				</div>
				@if (statsDifferenceExpand$.value) {
				<div class="summed-report-time flex flex-row justify-between items-center ml-6">
					<div class="flex items-center gap-1">
						<mat-icon [style.color]="'#0C8875'">stop</mat-icon>
						<span class="summed-report-time-header">{{ 'schedules.dashboard.overtime' | translate }}</span>
					</div>
					<span>{{ tds.overtime | parseMsAsDuration: false : true }}</span>
				</div>
				<div class="summed-report-time flex flex-row justify-between items-center ml-6 pt-2">
					<div class="flex items-center gap-1">
						<mat-icon [style.color]="'#FF594B'">stop</mat-icon>
						<span class="summed-report-time-header">{{ 'schedules.dashboard.missing' | translate }}</span>
					</div>
					<span>{{ tds.missing | parseMsAsDuration: false : true }}</span>
				</div>
				} } @if ((data$Visible | async ).showAbsence && this.comegoEnabled$ | async) {<!-- drop down for
				Absences -->
				<div class="summed-report-time flex flex-row justify-between items-center pt-2">
					<div class="flex items-center gap-1">
						<mat-icon [style.color]="'#9356e3'">stop</mat-icon>
						<span class="summed-report-time-header">{{ 'schedules.dashboard.absence' | translate }}</span>
					</div>
					<div class="flex items-center gap-1">
						<span>{{ tds.absence | parseMsAsDuration: false : true }}</span>
						@if ((absencesSubcategories$stats | async)?.length) {
						<mat-icon (click)="statsAbsencesExpand$.update(!statsAbsencesExpand$.value)">
							{{ statsAbsencesExpand$.value ? 'keyboard_arrow_up' : 'keyboard_arrow_left' }}
						</mat-icon>
						}
					</div>
				</div>
				@if (statsAbsencesExpand$.value) {<!-- list of absencesSubcategories--> @for (absence of
				absencesSubcategories$stats | async; track absence.id) {
				<div class="summed-report-time flex flex-row justify-between items-center ml-3 pt-2">
					<div class="flex items-center gap-1">
						<mat-icon [style.color]="'#9356e3'">stop</mat-icon>
						@if (absence.name == 'defaultAbsences') {
						<span
							[matTooltip]="'schedules.dashboard.absence' | translate"
							class="summed-report-time-header"
							>{{
								'schedules.dashboard.absence' | translate
							}}</span
						>} @else {<span
							[matTooltip]="absence | parseMsAsDuration"
							class="summed-report-time-header"
							>{{
								absence | absenceTranslate
							}}</span
						>}
					</div>
					<span>{{ absence.value | parseMsAsDuration: false : true }}</span>
				</div>
				} } }
			</div>
		</div>
		<div
			[style.height.px]="180"
			[style.width.px]="220"
			class="mt-4 sm:flex-auto"
		>
			<div class="pieChart-container">
				<app-loader
					[enableCircle]="true"
					[isActive]="this.timeLoading$ | async"
					[isAfterViewInit]="false"
					class="rounded"
				></app-loader>
			</div>
		</div>
	</div>
	}
</ng-template>
